"use strict";
let toExport = {};

function getAnyClass(obj) {
  if (typeof obj === "undefined") return "undefined";
  if (obj === null) return "null";
  return obj.constructor.name;
}

toExport.compactImageFromFile = async function(file, type='image/jpeg', quality=0.9, maxWidth=0, maxHeight=0) {
  return new Promise(async (resolve)=>{
    try {
      if(!(file instanceof File)) {
        console.log('file is not instanceof File', file, getAnyClass(file));
        return resolve({isOk: false});
      }
      if(!type) {
        type = 'image/jpeg';
      }
      if(!quality) {
        quality = 0.9;
      }

      const reader = new FileReader();
      reader.onerror = error => {
        console.error('Erro ao ler arquivo', error);
        resolve({isOk: false});
      };
      reader.onload = (event) => {
        // event.target.result;
        const img = new Image();

        img.onload = () => {
          const elem = document.createElement('canvas');
          let w = img.width;
          let h = img.height;
          if(maxWidth && w>maxWidth) {
            h = Math.floor((h*maxWidth)/w);
            w = maxWidth;
          }
          if(maxHeight && h>maxHeight) {
            w = Math.floor((w*maxHeight)/h);
            h = maxHeight;
          }

          elem.width = w;
          elem.height = h;
          const ctx = elem.getContext('2d');
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, elem.width, elem.height);
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, w, h);
          ctx.canvas.toBlob((blob) => {
            const dataUrl = ctx.canvas.toDataURL(type, quality);
            resolve({isOk: true, blob, dataUrl});
          }, type, quality);
        };
        img.src = event.target.result;

      };
      reader.readAsDataURL(file);
    } catch(error) {
      console.error('Error on preProcessImage', error);
      resolve({isOk: false});
    }
  });
};

toExport.getSizesFromDataUrl = async function(file) {
  return new Promise(async (resolve)=>{
    try {
      if(typeof file !=='string') {
        console.log('file is not DataUrl', file);
        return resolve({isOk: false});
      }
      const img = new Image();
      img.onload = () => {
        resolve({isOk: true, w: img.width, h: img.height});
      }
      img.onerror = () => {
        resolve({isOk: false});
      }
      img.src = file;
    } catch(error) {
      console.error('Error on preProcessImage', error);
      resolve({isOk: false});
    }
  });
}

toExport.compactImageFromDataUrl = async function(file, type='image/jpeg', quality=0.9, maxWidth=0, maxHeight=0) {
  return new Promise(async (resolve)=>{
    try {
      if(typeof file !=='string') {
        console.log('file is not DataUrl', file);
        return resolve({isOk: false});
      }
      if(!type) {
        type = 'image/jpeg';
      }
      if(!quality) {
        quality = 0.9;
      }
      const img = new Image();
      img.onload = () => {
        const elem = document.createElement('canvas');
        let w = img.width;
        let h = img.height;
        if(maxWidth && w>maxWidth) {
          h = Math.floor((h*maxWidth)/w);
          w = maxWidth;
        }
        if(maxHeight && h>maxHeight) {
          w = Math.floor((w*maxHeight)/h);
          h = maxHeight;
        }

        elem.width = w;
        elem.height = h;
        const ctx = elem.getContext('2d');
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, elem.width, elem.height);
        // img.width and img.height will contain the original dimensions
        ctx.drawImage(img, 0, 0, w, h);
        ctx.canvas.toBlob((blob) => {
          const dataUrl = ctx.canvas.toDataURL(type, quality);
          resolve({isOk: true, blob, dataUrl, w: w, h: h});
        }, type, quality);
      };
      img.src = file;
    } catch(error) {
      console.error('Error on preProcessImage', error);
      resolve({isOk: false});
    }
  });
};



module.exports = toExport;





